interface SpinnerState {
    isLoading: boolean;
    isAcceptingInvitation: boolean;
}

export type SetLoadingAction = {
    type: 'setLoading',
    payload: boolean
}

export type SetAcceptingInvitationAction = {
    type: 'setAcceptingInvitation',
    payload: boolean
}

type SpinnerAction = SetLoadingAction | SetAcceptingInvitationAction;

const initalState: SpinnerState = {
    isLoading: false,
    isAcceptingInvitation: false,
}

export const spinnerReducer = (state = initalState, action: SpinnerAction) => {
    switch (action.type) {
        case "setLoading":
            return { ...state, isLoading: action.payload }
        case "setAcceptingInvitation":
            return { ...state, isAcceptingInvitation: action.payload }
        default:
            return state;
    }
};
